import React, { useState, useEffect } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Employee } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { createEmployeeEntry } from '../../Store/PHPSlice/Employee';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const EmployeeEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        empName: '',
        ph: '',
        emailId: 'abc@gmail.com',
        category: '',
        departId: '',
        payType: '',
        amt: '0',
        teamleader: 0,
        punchId: 0,
        userId: userdata?.ID
    });
    const [departlist, setDepartlist] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        departId: fetchDepartmentData
        // Add more mappings if needed
    };
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const department = useSelector((state) => state.DepartmentData.department || { data: [] });
    useEffect(() => {
        dispatch(fetchDepartmentData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (formData.category === '1') {
            const filterDepart = department?.data?.filter(
                (item) => item.departNm !== 'CUT-TO-PACK' && item.departNm !== 'STITCH-TO-PACK'
            ) || []; // Fallback to empty array if undefined
            setDepartlist(filterDepart);
        } else {
            setDepartlist(department?.data || []); // Fallback to empty array if undefined
        }
    }, [formData.category]);
    // console.log(departlist);
    if (!department) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'amt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.empName) newErrors.empName = 'Employee Name is required';
        // if (!formData.emailId) newErrors.emailId = 'Email is required';
        if (!formData.amt) newErrors.amt = 'Amount is required';
        if (!formData.ph) {
            newErrors.ph = 'Contact is required';
        } else if (!/^\d{10}$/.test(formData.ph)) {
            newErrors.ph = 'Contact must be a 10-digit number';
        }
        // if (!formData.departId) newErrors.departId = 'Department Name is required';
        if (!formData.payType) newErrors.payType = 'Payment Type is required';
        if (!formData.category) newErrors.category = 'Category is required';

        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        dispatch(createEmployeeEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Employee Added");
                alert("Employee Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };


    const PaymentType = [
        { label: 'Weekly', value: 1 },
        { label: 'Monthly', value: 2 },
        { label: 'On-Work', value: 3 }
    ]

    const teamLeader = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];

    const Categorylist = [
        { label: 'In-House', value: '1' },
        { label: 'Contractor', value: '2' }
    ];

    const handleNavigateDepart = () => {
        window.open(`/new-department-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };


    const dropdownDepartment = [
        {
            label: 'Department',
            id: 'departId',
            options: departlist || [],
            value: formData.departId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateDepart(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('departId'),
            handleDropdownClose: () => handleDropdownClose('departId'),
        }
    ];

    return (
        <>
            <Titlebar data={Employee} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Employee Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Employee Name', name: 'empName' },
                                    { label: 'Contact', name: 'ph' },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Punching Id', name: 'punchId' },
                                    { label: 'Amount', name: 'amt' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="departId">Department Selection :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.departId}>
                                                <Select
                                                    labelId="departId"
                                                    id="departId"
                                                    name="departId"
                                                    value={formData.departId}
                                                    onChange={(e) => handleDropdownChange(e, 'departId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        department?.data?.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.departNm}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.departId && <FormHelperText style={errorStyles}>{errors.departId}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="payType">Payment Type :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.payType}>
                                                <Select
                                                    labelId="payType"
                                                    id="payType"
                                                    name="payType"
                                                    value={formData.payType}
                                                    onChange={(e) => handleDropdownChange(e, 'payType')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        PaymentType.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.payType && <FormHelperText style={errorStyles}>{errors.payType}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="category">Category :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.payType}>
                                                <Select
                                                    labelId="category"
                                                    id="category"
                                                    name="category"
                                                    value={formData.category}
                                                    onChange={(e) => handleDropdownChange(e, 'category')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        Categorylist?.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.category && <FormHelperText style={errorStyles}>{errors.category}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {dropdownDepartment?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                                }



                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="teamleader">Team Leader :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="teamleader"
                                                    id="teamleader"
                                                    name="teamleader"
                                                    value={formData.teamleader}
                                                    onChange={(e) => handleDropdownChange(e, 'teamleader')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        teamLeader.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default EmployeeEntry;